import { CheckSquareOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Link } from 'react-router-dom';
import { MobileStatGrid, MobileWorkbenchCard } from '@/components/mobile/MobileWorkbenchCard';
import { ReportStatusBadge } from '@/components/mobile/ReportStatusBadge';
import { ROUTES } from '@/constants/routes';
import { useEmployeeDashboard } from '@/hooks/useEmployeeDashboard';
import { useEmployeeTaskStats } from '@/hooks/useEmployeeTaskStats';
import { shouldShowWriteAction } from '@/utils/employee-dashboard';
import { getLocalDateKey } from '@/utils/date';

export function EmployeeHomePage() {
  const { loading, todayStatus, todayStatusMeta, reload } = useEmployeeDashboard();
  const {
    loading: taskStatsLoading,
    stats: taskStats,
    reload: reloadTaskStats,
  } = useEmployeeTaskStats();

  const reportsLink = `${ROUTES.mobile.employee.reports}?tab=today`;
  const viewLink = `${ROUTES.mobile.employee.reports}?tab=today&mode=view`;

  return (
    <div className="mobile-workbench">
      <section className="mobile-section">
        <div className="mobile-section__header">
          <span className="mobile-section__title">今日日报</span>
          <span className="mobile-section__meta">{getLocalDateKey()}</span>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 16 }}>
            <Spin size="small" />
          </div>
        ) : (
          <div className="mobile-status-row">
            <span className="mobile-section__meta">当前状态</span>
            <ReportStatusBadge meta={todayStatusMeta} />
          </div>
        )}
        {shouldShowWriteAction(todayStatus) ? (
          <MobileWorkbenchCard
            accent
            title="写日报"
            description="填写并提交今日工作内容"
            to={reportsLink}
            icon={<EditOutlined />}
          />
        ) : (
          <MobileWorkbenchCard
            title="查看日报"
            description="查看今日已提交的日报内容"
            to={viewLink}
            icon={<EyeOutlined />}
          />
        )}
      </section>

      <section className="mobile-section">
        <div className="mobile-section__header">
          <span className="mobile-section__title">我的任务</span>
        </div>
        {taskStatsLoading ? (
          <div style={{ textAlign: 'center', padding: 12 }}>
            <Spin size="small" />
          </div>
        ) : (
          <>
            <MobileStatGrid>
              <Link className="mobile-stat-item mobile-stat-item--default mobile-stat-item--link" to={ROUTES.mobile.employee.tasks}>
                <div className="mobile-stat-item__value">{taskStats.total}</div>
                <div className="mobile-stat-item__label">我的任务</div>
              </Link>
              <Link
                className="mobile-stat-item mobile-stat-item--warning mobile-stat-item--link"
                to={ROUTES.mobile.employee.tasks}
              >
                <div className="mobile-stat-item__value">{taskStats.pendingComplete}</div>
                <div className="mobile-stat-item__label">待完成任务</div>
              </Link>
              <Link
                className="mobile-stat-item mobile-stat-item--default mobile-stat-item--link"
                to={`${ROUTES.mobile.employee.tasks}?tab=overdue`}
              >
                <div className="mobile-stat-item__value">{taskStats.overdue}</div>
                <div className="mobile-stat-item__label">已逾期任务</div>
              </Link>
            </MobileStatGrid>
            <Link className="mobile-section-link" to={ROUTES.mobile.employee.tasks}>
              <CheckSquareOutlined /> 进入任务中心
            </Link>
          </>
        )}
      </section>

      <button
        type="button"
        className="mobile-text-btn"
        onClick={() => {
          void reload();
          void reloadTaskStats();
        }}
      >
        刷新数据
      </button>
    </div>
  );
}
